import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p486197095444975616',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
